document.addEventListener("DOMContentLoaded", function () {
    const t = document.getElementById("countrySelect"),
        e = document.getElementById("flagIcon"),
        a = document.getElementById("ContactPhone"),
        n = t.selectedOptions[0].dataset.iso;
    (e.src = `https://flagcdn.com/24x18/${n}.png`),
        (a.value = t.value + " "),
        t.addEventListener("change", function () {
            const t = this.selectedOptions[0].dataset.iso,
                n = this.value;
            (e.src = `https://flagcdn.com/24x18/${t}.png`), a.value.startsWith(n) || ((a.value = n + " "), a.focus());
        });
}),
    document.addEventListener("DOMContentLoaded", function () {
         if (document.querySelector(".wt-parallax__slick")) {
            !(function t() {
                "undefined" != typeof $ && $.fn.slick
                    ?  $(".wt-parallax__slick").slick({
                          infinite: !0,
                          autoplay: !0,
                          autoplaySpeed: 5e3,
                          pauseOnHover: !0,
                          fade: !0,
                          speed: 1e3,
                          arrows: !0,
                          dots: !1,
                          prevArrow:
                              '<button type="button" class="slick-prev" aria-label="Previous slide"><svg class="svg-icon svg-icon--arrow-left " aria-hidden="true" id="" focusable="false" role="presentation" xmlns="http://www.w3.org/2000/svg" data-icon-theme="option_4" width="72" height="72" viewBox="0 0 72 72">                    <title></title>                <g id="Arrow_left" data-name="Arrow left" transform="translate(-36 -511)">                <g id="arr_left" transform="translate(23289 11206)">                    <g id="Group_11367" data-name="Group 11367">                        <rect id="Rectangle_29189" data-name="Rectangle 2918" width="72" height="72" transform="translate(-23253 -10695)" fill="none"></rect>                        <path id="chevron-left" d="M35.628,87.789l.876-.876a1.487,1.487,0,0,0,0-2.1L12.281,60.587,36.5,36.365a1.487,1.487,0,0,0,0-2.1l-.876-.876a1.487,1.487,0,0,0-2.1,0L7.375,59.536a1.487,1.487,0,0,0,0,2.1l26.15,26.15a1.487,1.487,0,0,0,2.1,0Z" transform="translate(-23239.939 -10719.95)"></path>                    </g>                </g>            </g>        </svg></button>',
                          nextArrow:
                              '<button type="button" class="slick-next" aria-label="Next slide"><svg class="svg-icon svg-icon--arrow-right " aria-hidden="true" id="" focusable="false" role="presentation" xmlns="http://www.w3.org/2000/svg" data-icon-theme="option_4" width="72" height="72" viewBox="0 0 72 72">                    <title></title>                <g id="Arrow_right" data-name="Arrow right" transform="translate(108 583) rotate(180)">                <g id="arr_right" transform="translate(23289 11206)">                    <g id="Group_11366" data-name="Group 11366">                        <rect id="Rectangle_291811" data-name="Rectangle 2918" width="72" height="72" transform="translate(-23253 -10695)" fill="none"></rect>                        <path id="chevron-right" d="M35.628,87.789l.876-.876a1.487,1.487,0,0,0,0-2.1L12.281,60.587,36.5,36.365a1.487,1.487,0,0,0,0-2.1l-.876-.876a1.487,1.487,0,0,0-2.1,0L7.375,59.536a1.487,1.487,0,0,0,0,2.1l26.15,26.15a1.487,1.487,0,0,0,2.1,0Z" transform="translate(-23239.939 -10719.95)"></path>                    </g>                </g>            </g>        </svg></button>',
                          responsive: [{ breakpoint: 768, settings: { arrows: !1, dots: !0 } }],
                      })
                    : setTimeout(t, 100);
            })();
        }
        // if (document.querySelector(".hotspot_slider")) {
        //     !(function t() {
        //         "undefined" != typeof $ && $.fn.slick
        //             ?  $(".hotspot_slider").slick({
        //                     infinite: true,
        //                     slidesToShow: 3,
        //                     slidesToScroll: 1,
        //                     autoplay: true,
        //                     autoplaySpeed: 5000,
        //                     pauseOnHover: true,
        //                     arrows: true,
        //                     dots: false,
        //                     speed: 1000,
        //                     responsive: [
        //                         {
        //                             breakpoint: 768, // for tablets and smaller
        //                             settings: {
        //                                 slidesToShow: 1,
        //                                 arrows: false,
        //                                 dots: true
        //                             }
        //                          }
        //                     ]
        //                 });
        //             : setTimeout(t, 100);
        //     })();
        // }
    });

/* Alia email popup (full screen), 2026-10-20: two problems of the app's own layout on desktop.
   1) Its photo is a fixed 800 px block on the right while the white panel is ~58% of the screen: on screens wider
      than ~1900 px a strip of the page showed between the panel's curve and the photo. The photo block is widened
      to reach under the panel (its picture is a cover background, so it just shows more of it).
   2) On desktop it didn't lock the page: scrolling moved the product page behind it. The page is locked while the
      popup is open (on phones Alia already does it). */
(() => {
  const isOpenPopup = (root) => {
    if (!root || !root.isConnected) return false;
    const cs = getComputedStyle(root);
    const r = root.getBoundingClientRect();
    return cs.display !== 'none' && cs.visibility !== 'hidden' && r.width >= window.innerWidth * 0.9 && r.height >= window.innerHeight * 0.9 && root.querySelector('div');
  };
  const fixPhoto = (root) => {
    if (window.innerWidth < 750) return;
    root.querySelectorAll('div').forEach((d) => {
      if (d.dataset.sbAliaPhoto) return;
      const cs = getComputedStyle(d);
      if (cs.position !== 'absolute' || !/alia-prod\.com/.test(cs.backgroundImage)) return;
      const r = d.getBoundingClientRect();
      if (r.width < 200 || r.height < window.innerHeight * 0.8 || r.right < window.innerWidth - 2) return; // the right-hand photo only
      d.dataset.sbAliaPhoto = '1';
      d.style.setProperty('width', 'max(800px, 60%)', 'important');
      d.style.setProperty('left', 'auto', 'important');
      d.style.setProperty('right', '0', 'important');
      if (cs.backgroundSize === 'auto' || !cs.backgroundSize) d.style.setProperty('background-size', 'cover', 'important');
    });
  };
  let locked = false;
  const check = () => {
    const open = [...document.querySelectorAll('[id^="alia-root"]')].find(isOpenPopup);
    if (open) fixPhoto(open);
    if (!!open !== locked) {
      locked = !!open;
      document.documentElement.classList.toggle('sb-alia-open', locked);
    }
  };
  let queued = false;
  const queue = () => { if (queued) return; queued = true; requestAnimationFrame(() => { queued = false; check(); }); };
  // Light: only watch <body>'s own children (Alia appends its root there) and, once it exists, the root itself
  const watched = new WeakSet();
  const watchRoots = () => {
    document.querySelectorAll('[id^="alia-root"]').forEach((root) => {
      if (watched.has(root)) return;
      watched.add(root);
      new MutationObserver(queue).observe(root, { childList: true, subtree: true, attributes: true, attributeFilter: ['style', 'class'] });
    });
    queue();
  };
  new MutationObserver(watchRoots).observe(document.body, { childList: true });
  watchRoots();
  window.addEventListener('resize', () => { document.querySelectorAll('[data-sb-alia-photo]').forEach((d) => delete d.dataset.sbAliaPhoto); queue(); });
})();
